/* 我的-钱包 */
<template>
  <div class="my-pouch">
    <!-- 头部 -->
    <headerTop title="钱包" :isCustomeBack="true" @customeBackEvent="customeBack"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <!-- 明细 -->
      <div class="detailed">
        <div class="detailed-l"></div>
        <div class="detailed-r" @click="toBill">
          <span>查看明细</span>
          <span class="iconfont iconyoujiantou"></span>
        </div>
      </div>
      <!-- 余额 -->
      <div class="content-details-box balance">
        <div class="content-details">
          <div class="content-item">
            <div class="content-item-l">余额</div>
            <div class="content-item-r">¥{{ account.totalBalance }}</div>
          </div>
        </div>
      </div>
      <!-- 可用余额 -->
      <div class="content-details-box available-balance">
        <div class="content-details">
          <div class="content-item">
            <div class="content-item-l">可用余额</div>
            <div class="content-item-r">¥{{ account.balance }}</div>
          </div>
        </div>
      </div>
      <!-- 在途资金 -->
      <div class="content-details-box capital">
        <div class="content-details">
          <div class="content-item">
            <div class="content-item-l">在途资金</div>
            <div class="content-item-r">¥{{ account.freezeBalance }}</div>
          </div>
          <div class="content-remind">正在申请提现，暂时不能使用的金额</div>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="foot-btn">
      <div class="cash-btn" @click="toReflect">提现</div>
      <div class="cash-btn" @click="toTransfer">转账</div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import javaApi from "@/api/javaApi";

export default {
  data() {
    return {
      account: {}
    };
  },
  components: {
    headerTop
  },
  mounted() {
    javaApi.accountDetail().then(res => {
      this.account = res;
    });
  },
  methods: {
    customeBack() {
      this.$router.push({ name: "myUserHome" });
    },
    toRecharge() {
      this.$router.push({
        name: "recharge"
      });
    },
    toBill() {
      this.$router.push({
        name: "bill"
      });
    },
    toReflect() {
      this.$router.push({
        name: "reflect"
      });
    },
    toTransfer() {
      this.$router.push({
        name: "transfer"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.my-pouch {
  position: relative;
  .content {
    .detailed {
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 10px 20px;
      .detailed-r {
        font-size: 14px;
        color: #999999;
        display: flex;
        align-content: center;
        & span:nth-child(1) {
        }
        .iconyoujiantou {
          font-size: 12px;
          margin-left: 10px;
        }
      }
    }
    .content-details-box {
      padding: 0 29px;
      .content-details {
        height: 72px;
        border-bottom: 1px solid #e4e4e4;
        .content-item {
          width: 100%;
          padding-top: 27px;
          display: flex;
          justify-content: space-between;
          .content-item-l {
            font-size: 14px;
            color: #666666;
          }
          .content-item-r {
            font-size: 18px;
            color: #ea2c2c;
          }
        }
      }
    }
    .available-balance,
    .capital,
    .give {
      .content-item-r {
        font-size: 18px;
        color: #1d1d1d !important;
      }
    }
    .capital,
    .give {
      .content-remind {
        font-size: 12px;
        color: #b2b2b2;
      }
    }
  }
  .foot-btn {
    padding: 0 15px;
    padding-top: 40px;
    .recharge-btn {
      width: 100%;
      height: 44px;
      background: #8a3e2f;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 44px;
    }
    .cash-btn {
      width: 100%;
      height: 42px;
      margin-top: 30px;
      background: #ffffff;
      border: 1px solid #8a3e2f;
      font-size: 18px;
      color: #8a3e2f;
      text-align: center;
      line-height: 44px;
    }
  }
}
</style>
